import { createContext, ReactElement, useContext } from 'react';

import { ITableProps } from './interfaces/ITableProps';
import { IFilterCellComponent } from './components/TableHeadCell/IFilterCellProps';

export type IRenderGenericTable = <D, S extends string = string, F extends string = string>(
  props: Omit<ITableProps<D, S, F>, 'filterComponents'>
) => ReactElement | null;

export const GenericTableContext = createContext<{
  renderGenericTable: IRenderGenericTable;
  filterComponents: IFilterCellComponent[];
}>({ renderGenericTable: () => null, filterComponents: [] });

export const useGenericTableContext = () => useContext(GenericTableContext);
